<template>
  <div class="ai-preview">
    <div class="ai-preview__hd">
      <h3 class="main-title">AI实时文本</h3>
      <p>14:00:00</p>
      <p>大家好，欢迎参加本次的直播活动</p>
    </div>
    <div class="ai-preview__bd">
      <h3 class="main-title">AI纪要</h3>
      <h3 class="sub-title">B端企业直播</h3>
      <p>对于面向B端企业客户的直播，关键在于精准描述用户画像并进行精准推送。</p>
    </div>
    <div class="ai-preview__ft">温馨提示：内容由AI模型生成，内容仅供参考</div>
  </div>
</template>
<script>
  export default {
    props: {
      menuInfo: {
        required: false
      }
    },
    name: 'component-ai'
  };
</script>
<style lang="less">
  .ai-preview {
    display: flex;
    flex-direction: column;
    height: 100%;
    line-height: 1.5;
    padding: 0 16px;
    font-size: 14px;

    &__hd {
      margin-bottom: 16px;
    }
    &__bd {
      flex: 1;
    }
    &__ft {
      color: #6c6c6c;
      font-size: 12px;
      margin-bottom: 6px;
    }

    .main-title {
      font-size: 16px;
      color: #fb2626;
    }
    .sub-title {
      font-weight: bold;
    }
  }
</style>
